import { render, staticRenderFns } from "./memberList.vue?vue&type=template&id=ca8ba52c&scoped=true&"
import script from "./memberList.vue?vue&type=script&lang=js&"
export * from "./memberList.vue?vue&type=script&lang=js&"
import style0 from "./memberList.vue?vue&type=style&index=0&id=ca8ba52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8ba52c",
  null
  
)

export default component.exports